module.exports = __webpack_public_path__ + "static/img/2_8.aee7857d.jpg";